import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import EchangesList from '../../../composants/EchangesList/EchangesList';
import TableauDeBord from '../../../composants/TableauDeBord/TableauDeBord';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import Button from '../../../composants/Button/Button';
import { ReactComponent as PdfIcon } from '../../../assets/icons/pdf.svg';
import { exportHistoriquePdf } from '../../../utils/exportHistoriquePdf';
import { OperationMS, HistoriqueEvent } from '../types';
import './OperationHistoriqueMarche.css';

interface OperationHistoriqueMarcheProps {
  operation: OperationMS;
}

// Onglet "Historique" de la vue acheteur operation-MS (V2).
// Fork autonome de l'ancien composant partage SuiviDuMarche : aucun discriminateur
// de role/type, l'element suivi est toujours une operation MS.
//   - typeElement fige a 'operation' (idElement = operation.id) pour les memos.
//   - Historique = tableau des evenements operation.historique.
const OperationHistoriqueMarche: React.FC<OperationHistoriqueMarcheProps> = ({ operation }) => {
  const { user } = useAuth();

  const currentUser = {
    id: user?.id ?? null,
    name: user?.name ?? 'Utilisateur',
    role: user?.role ?? 'user',
  };

  const formatDate = (dateString?: string): string => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const historiqueColumns = [
    {
      field: 'date',
      header: 'Date',
      renderCell: (_: unknown, row?: HistoriqueEvent) => (
        <div className="date-cell">{formatDate(row?.created_at)}</div>
      ),
    },
    {
      field: 'operateur',
      header: 'Opérateur',
      renderCell: (_: unknown, row?: HistoriqueEvent) => (
        <div className="operateur-cell">{row?.operateur || '-'}</div>
      ),
    },
    {
      field: 'action',
      header: 'Action',
      renderCell: (_: unknown, row?: HistoriqueEvent) => (
        <div className="action-cell">{row?.prefix || '-'}</div>
      ),
    },
    {
      field: 'description',
      header: 'Description',
      renderCell: (_: unknown, row?: HistoriqueEvent) => (
        <div className="description-cell">{row?.label || '-'}</div>
      ),
    },
  ];

  const historique = operation.historique ?? [];

  return (
    <div className="tab-suivi-marche">
      <SectionPliable title="Historique">
        {historique.length > 0 ? (
          <TableauDeBord
            data={historique}
            columns={historiqueColumns}
            onSearch={() => {}}
            showActionsColumn={false}
            isSelectable={false}
            selectedItems={[]}
            onSelectionChange={() => {}}
            footerLeft={
              <Button
                value="Télécharger le PDF"
                variant="secondary"
                icon={<PdfIcon />}
                onClick={() => exportHistoriquePdf(historique, 'Historique', currentUser.name)}
              />
            }
          />
        ) : (
          <div className="empty-state">Aucun historique disponible</div>
        )}
      </SectionPliable>
      <SectionPliable title="Mémo interne">
        <EchangesList
          typeElement="operation"
          idElement={operation.id}
          currentUser={currentUser}
          showCommentaireForm={true}
        />
      </SectionPliable>
    </div>
  );
};

export default OperationHistoriqueMarche;
